import { Controller } from 'stimulus'
export default class extends Controller {
  static values = {
    sitekey: String,
    action: String
  }

  connect() {
    if(window.turnstile) {
      window.turnstile.render(this.element, {
        sitekey: this.sitekeyValue,
        action: this.actionValue
      });
    }
  }
}
